import antdPtBR from "antd/es/locale/pt_BR";
import pt from "./locales/pt_BR.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { THEME_CONFIG } from "configs/AppConfig";

export const resources = {
  pt: {
    translation: pt,
    antd: antdPtBR,
  },
  // en: {
  //   translation: en,
  //   antd: antdEnUS,
  // },
  // zh: {
  //   translation: zh,
  //   antd: antdZhCn,
  // },
  // fr: {
  //   translation: fr,
  //   antd: antdFrFR,
  // },
  // ja: {
  //   translation: ja,
  //   antd: antdJaJP,
  // },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: THEME_CONFIG.locale,
  lng: THEME_CONFIG.locale,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
